import NotFound from '@web-platform/global-components-not-found';
import { useRouteLoaderData } from 'react-router';
import { logError, logOperationalEvent, logWarn } from 'saddlebag-logger';

import type { loader as rootLoader } from '../../root';
import type { ExtractLoaderData } from '../../types';

export const GlobalNotFound = () => {
  const rootData = useRouteLoaderData<ExtractLoaderData<typeof rootLoader>>('root');
  const translations = rootData?.i18n.translations;

  // Should never happen — root loader always returns i18n. Throwing here
  // (instead of silently rendering nothing) lets the parent ErrorBoundary surface
  // the failure rather than leaving the user on a blank page.
  if (!translations) {
    throw new Error('GlobalNotFound: root loader translations are unavailable');
  }

  return (
    <NotFound
      buttonHref="/travel-tools"
      isProductionEnv={rootData?.isProductionEnv ?? false}
      logger={{ logError, logOperationalEvent, logWarn }}
      strings={{
        goBackLabel: translations.travel_tools_not_found_go_back,
        imageAltText: translations.travel_tools_not_found_image_alt,
        message: translations.travel_tools_not_found_message,
        title: translations.travel_tools_not_found_title,
      }}
    />
  );
};
